import { Injectable } from "@angular/core";
import {
  AngularFirestore,
  AngularFirestoreCollection,
  CollectionReference,
  Query,
} from "@angular/fire/firestore";

import * as firebase from "firebase/app";
import "firebase/firestore";
import * as moment from "moment";

import { environment } from "../../environments/environment";
import { User } from "../@core/data/users";
import { UserService } from "../@core/services/user.service";
import { Project } from "../models/project.model";

@Injectable({
  providedIn: "root",
})
export class ProjectService {
  visibility = environment.visibility;
  userLogin: User;
  private dbPath = "/shops";

  collRef: AngularFirestoreCollection<Project>;

  constructor(private db: AngularFirestore, private userStore: UserService) {
    this.userStore.getCurrentUser().subscribe((user: User) => {
      if (user) {
        this.userLogin = user;
        this.visibility = user.companyId
          ? user.companyId
          : environment.visibility;
      }
    });
  }

  getProjects(shopId: string): AngularFirestoreCollection<Project> {
    return this.db.collection(this.dbPath + `/${shopId}/projects`, (ref) =>
      ref
        .where("isDeleted", "==", false)
        .where("isActive", "==", true)
        .orderBy("updatedOn", "desc")
    );
  }

  get(shopId: string, id: string) {
    return this.db
      .collection(this.dbPath + `/${shopId}/projects`)
      .doc(id)
      .valueChanges();
  }

  create(project: Project): any {
    project.isActive = true;
    project.isDeleted = false;
    project.createdOn = new Date();
    project.createdBy = this.userLogin.uid;
    project.updatedOn = new Date();
    project.updatedBy = this.userLogin.uid;
    project.author = this.userLogin;
    project.visibility = this.visibility;

    project.shopId = project.shopId ? project.shopId : this.userLogin.shopId;
    this.collRef = this.db.collection(
      this.dbPath + `/${project.shopId}/projects`
    );

    return this.collRef.add({ ...project }).then((docRef) => {
      project.id = docRef.id;
      return project;
    });
  }

  update(project: Project): Promise<void> {
    console.log("update project:", project);

    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;

    this.collRef = this.db.collection(
      this.dbPath + `/${project.shopId}/projects`
    );
    return this.collRef.doc(project.id).update({
      title: project.title,
      description: project.description ? project.description : "",
      why: project.why ? project.why : "",
      how: project.how ? project.how : "",
      what: project.what ? project.what : "",
      purpose: project.purpose ? project.purpose : "",
      startDate: project.startDate
        ? moment(project.startDate).startOf("day").toDate()
        : moment().startOf("day").toDate(),
      endDate: project.endDate
        ? moment(project.endDate).endOf("day").toDate()
        : moment().endOf("day").toDate(),
      rules: project.rules ? project.rules : "",
      budget: project.budget ? project.budget : 0,
      tags: project.tags ? project.tags : [],
      coverUrl: project.coverUrl ? project.coverUrl : "",
      sourceType: project.sourceType,
      content: project.content ? project.content : "",
      videoUrl: project.videoUrl ? project.videoUrl : "",
      imagesUrl: project.imagesUrl ? project.imagesUrl : [],

      updatedOn: updatedOn,
      updatedBy: updatedBy,
      timestamp: new Date().getTime(),
    });
  }

  delete(shopId: string, id: string): Promise<void> {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;
    this.collRef = this.db.collection(this.dbPath + `/${shopId}/projects`);
    return this.collRef.doc(id).update({
      isDeleted: true,
      updatedOn: updatedOn,
      updatedBy: updatedBy,
      timestamp: new Date().getTime(),
    });
  }
}
